import React from "react";
import {MapPage} from "./map_components";
import {createRoot} from 'react-dom/client';


const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <MapPage onlyFeatured={false}/>
);
